<template>
  <div v-if="postData" class="block-event-meta event-meta">
    <div v-if="startDate && startDate === endDate" class="date start">
      {{ startDate }}
    </div>
    <div v-if="startDate !== endDate" class="date detal">{{ dateDetalis }}</div>
    <div class="date time">
      <span class="start">{{ startTime }}</span>
      <span v-if="startTime !== endTime" class="end"> - {{ endTime }}</span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
//require("moment/min/locales.min");
moment.locale("nb");

import { mapGetters } from "vuex";

export default {
  name: "event-meta",
  props: {
    id: Number
  },
  computed: {
    ...mapGetters(["getPageById"]),
    postData() {
      let post = null;
      if (this.id) {
        post = this.getPageById(this.id);
      }
      return post;
    },
    startDate() {
      let date = null;
      if (this.postData) {
        const startDate = this.postData.acf.start_date;
        date = moment(startDate).format("DD. MMMM YYYY");
      }
      return date;
    },
    startTime() {
      const startDate = this.postData.acf.start_date;
      return moment(startDate).format("HH:mm");
    },
    endDate() {
      const endDate = this.postData.acf.end_date;
      return moment(endDate).format("DD. MMMM YYYY");
    },
    endTime() {
      const endDate = this.postData.acf.end_date;
      return moment(endDate).format("HH:mm");
    },
    dateDetalis() {
      const startDate = this.postData.acf.start_date;
      const endDate = this.postData.acf.end_date;
      const startMonth = moment(startDate).format("MMMM");
      const endMonth = moment(endDate).format("MMMM");
      let formatDate = null;

      if (this.startDate !== this.endDate) {
        if (startMonth !== endMonth) {
          formatDate =
            moment(startDate).format("DD. MMMM") +
            " - " +
            moment(endDate).format("DD. MMMM");
        } else {
          formatDate =
            moment(startDate).format("DD") +
            " - " +
            moment(endDate).format("DD. MMMM YYYY");
        }
      }
      return formatDate;
    }
  },
  components: {}
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.block-event-meta {
  background-color: $fontColor;
  color: #fff;
  //margin-bottom: 50px;
  font-size: 16px;
  padding: 20px;
  .time {
    display: none !important;
  }
  div {
    margin-top: 5px;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
}
</style>
